export const INVITE_STORY_TEXT =
  'Wir feiern eine Freie Hochzeit mit mittelalterlichem Thema. Wir beide werden in vollem Kostüm erscheinen und ermutigen alle Gäste, ebenfalls in mittelalterlicher Kleidung zu kommen!'

export const INVITE_GIFT_TEXT =
  'Ihr edlen Gäste, wir bitten Euch: Bringet keine materiellen Gaben mit. Doch an der Feststätte erwartet Euch eine Schatztruhe, in die Ihr gerne einen Beitrag zur Finanzierung unserer Feier werfen könnt, solltet Ihr dies wünschen.'


